module.exports = __webpack_public_path__ + "img/radiaIcon1.4448efad.png";